import { FormlyFieldConfig } from '@ngx-formly/core';
import { ISaleCampaign } from '../../models/sale-campaign';

export class UrlUtilities {
  /** Returns the input string formatted as Title Case. */
  public static getCampaignUrl = (campaign: ISaleCampaign): string => {
    if (campaign.id) {
      return campaign && campaign.saleCode
        ? `${window.location.origin}/sale/${campaign.saleCode}/${campaign.title
            .split(' ')
            .join('-')}`
        : `${window.location.origin}/sale/${campaign.organizationId}/campaign-id/${campaign.id}/order`;
    }

    return undefined;
  };
}
